var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPdfNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.94741 0.414551L5.00006 1.4672L6.05271 2.51985M3.94741 0.414551H1V7.1515H6.05271V2.51985M3.94741 0.414551V2.51985H6.05271",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89468 2.51953L7.94733 3.57218L8.99998 4.62483M6.89468 2.51953V4.62483H8.99998M6.89468 2.51953H5.6315M8.99998 4.62483V9.25648H3.94727V7.15118",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdfNew);
export default __webpack_public_path__ + "static/media/icon-pdf-new.4dcd710091873204f884aeb44cb58a65.svg";
export { ForwardRef as ReactComponent };